import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import Image from 'next/image';
import { FunctionComponent } from 'react';

import css from './index.module.scss';

export const ThankYouMessage: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Box className={css.thankYouContainer}>
      <Text className={css.thankYouText}>
        {t('article-feedback.improved-feedback.message.thank-you-helpful')}
      </Text>
      <Image
        src="/images/icons/smile.svg"
        alt="smile"
        width={18}
        height={18}
        className={css.smileIcon}
        priority
        loading="eager"
      />
    </Box>
  );
};
